export default __webpack_public_path__ + "logo-ganmai.2a11748.png";